import { render, staticRenderFns } from "./UtterancesComments.vue?vue&type=template&id=32427b74&"
import script from "./UtterancesComments.vue?vue&type=script&lang=js&"
export * from "./UtterancesComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports